import React from "react";
import { FlatButton, RaisedButton, TextField } from "material-ui";

import connectToStores from "alt-utils/lib/connectToStores";
import PersonActions from "../../actions/PersonActions";
import PersonStore from "../../stores/PersonStore";

import PhoneField from "./phone-field.jsx";

@connectToStores
class ContactInfoUpdater extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      mailing_address: "",
      legal_name: "",
      phone_number: ""
    };

    this._update = this._update.bind(this);
  }

  static contextTypes = {
    tenant: React.PropTypes.object
  };

  static getStores() {
    return [PersonStore];
  }

  static getPropsFromStores() {
    return PersonStore.getState();
  }

  componentDidMount() {
    this.setState({
      mailing_address: this.props.details.mailing_address,
      phone_number: this.props.details.phone_number,
      legal_name: this.props.details.legal_name || this.props.details.name
    });
    if (this.field) {
      this.field.focus();
    }
  }

  _update() {
    PersonActions.edit(
      Object.assign(
        {},
        {
          mailing_address: this.state.mailing_address || undefined,
          phone_number: this.state.phone_number || undefined
        },
        this.props.includeLegalName && {
          legal_name: this.state.legal_name || undefined
        }
      )
    );
  }

  getStyles() {
    return {
      container: {
        maxWidth: 300,
        textAlign: "center",
        margin: "-1.5em auto 0"
      },
      actions: {
        marginTop: "1em"
      }
    };
  }

  render() {
    let styles = this.getStyles();
    const {
      includeLegalName,
      includeMailingAddress,
      includePhoneNumber
    } = this.props;

    const ready =
      (!includeLegalName || this.state.legal_name) &&
      (!includeMailingAddress || this.state.mailing_address) &&
      (!includePhoneNumber || this.state.phone_number);

    return (
      <div style={styles.container}>
        {this.props.includeLegalName ? (
          <TextField
            style={{ textAlign: "left" }}
            floatingLabelText="Full legal name (including middle initial)"
            floatingLabelFixed={true}
            value={this.state.legal_name}
            fullWidth={true}
            onChange={e => this.setState({ legal_name: e.target.value })}
          />
        ) : null}
        {this.props.includeMailingAddress ? (
          <TextField
            ref={r => {
              this.field = r;
            }}
            style={{ textAlign: "left", width: 256 }}
            floatingLabelText="Mailing address"
            floatingLabelFixed={true}
            hintText={
              <div style={{ textAlign: "left" }}>
                123 Main Street
                <br />
                New York, NY 10001
              </div>
            }
            multiLine={true}
            value={this.state.mailing_address}
            rows={2}
            rowsMax={2}
            fullWidth={true}
            onChange={e => this.setState({ mailing_address: e.target.value })}
          />
        ) : null}
        {this.props.includePhoneNumber ? (
          <PhoneField
            floatingLabelText="Phone number"
            floatingLabelFixed={true}
            autoFocus
            hintText="(123) 456-7890"
            value={this.state.phone_number}
            style={{}}
            onChange={e => this.setState({ phone_number: e.target.value })}
          />
        ) : null}

        <div style={styles.actions}>
          {/*<FlatButton
            label={this.props.cancelLabel || 'Cancel'}
            onClick={this.props.onCancel}
            style={{position: 'absolute', left: 24}}
          />*/}
          <RaisedButton
            label={
              this.props.editInProgress
                ? "Updating contact details..."
                : "Update contact details"
            }
            disabled={!ready || this.props.editInProgress}
            primary={true}
            onClick={this._update}
          />
        </div>
      </div>
    );
  }
}

export default ContactInfoUpdater;



// WEBPACK FOOTER //
// ./src/app/components/partials/contact-info-updater.jsx